import './abstract_section_view.coffee';# Added by Script 
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.BrandsOwnContents extends Monitoring.Reports.Executive.AbstractSectionView
  template: JST["backbone/templates/monitoring/reports/executive/brands_own_contents"]
  tagName: 'section'
  id: 'brands-own-contents'

  initialize: (@options = {}) ->
    @colors = {
      twitter: '#47bee8'
      facebook: '#4a66a0'
      video: '#dd7621'
      link: '#75ba57'
      photo: '#4197c1'
      status: '#ccb024'
      event: '#f9f62c'
    }
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color
    @brands = [@options.settings.accountLabel.codes[0]].concat (label.codes[0] for label in @options.settings.competitorsLabels)
    @sources = [{type: 'facebook', description: 'Facebook'} , {type: 'twitter', description: 'Twitter'}]
    

  render: ->
    @$el.html(@template(sources: @sources))
    @bindChartsReady(4)
    @addAllSources()
    _.each(@sources, (source) =>
      @addOneSource(source.type)
    )
    @addFacebookByTypes()
    return this

  addAllSources: ->
    query = @ownContentBaseQuery({ 
      second_dimension: 'type'
      sub_type: ['tweet', 'fb-post']
      exclude_twitter_replies: 'true'
      exclude_facebook_replies: 'true'
      must_be_public_comments: true

    })
    @_addBars(query,"#columns-all-source", { drillDownFunction: (clickEvent) ->
      type = clickEvent.point.series.name.toLowerCase()
      if type == 'twitter'
        exclusion = {exclude_twitter_replies: 'true'}
      else 
        exclusion = {exclude_facebook_replies: 'true'}
      $.extend({},{
        type: [type]
        labels: [clickEvent.point.code]
        sub_type: ['tweet', 'fb-post']
        include_page_owner_generated: true
        exclude_page_owner_generated: false
      }, exclusion)
    })

  addOneSource: (type) ->
    if type == 'twitter'
      specific = {exclude_twitter_replies: true, sub_type: ['tweet']}
    else 
      specific = {exclude_facebook_replies: true, sub_type: ['fb-post']}
    query = @ownContentBaseQuery(specific)
    @_addSimpleColumns(query,"#columns-source-#{type}", { drillDownFunction: (clickEvent) ->
      $.extend({},{
        type: [type]
        labels: [clickEvent.point.code]
        sub_type: ['tweet', 'fb-post']
        include_page_owner_generated: true
        exclude_page_owner_generated: false
      }, specific)
    })


  addFacebookByTypes: ->
    query = @ownContentBaseQuery({ 
      second_dimension: 'post_type'
      sub_type: ['fb-post']
      exclude_facebook_replies: 'true'
    })
    @_addNotStackedColumns(query,"#columns-by-type", { drillDownFunction: (clickEvent) ->
      {
        labels: [clickEvent.point.code]
        sub_type: ['fb-post']
        post_type: [clickEvent.point.series.name.toLowerCase()]
        include_page_owner_generated: true
        exclude_page_owner_generated: false
        exclude_facebook_replies: 'true'
      }
    })

  ownContentBaseQuery: (queryValues) ->
    query = {
      dimension: 'filtered_labels'
      first_dimension: 'filtered_labels'
      labels: @labelFilter()
      labels_structure: @labelsStructure()
      date_from_ISO: @options.fromISO.toISOString()
      date_to_ISO: @options.toISO.toISOString()
      include_page_owner_generated: true
    }
    for key of queryValues
      query[key] = queryValues[key]
    return query

    